import React, { useState, useEffect } from "react";
import { getContentById } from "../../API/content";
import ReactPlayer from "react-player";
import "./FeaturedVideos.css";

export default function FeaturedVideos() {
  const [videoData, setFeaturedData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await getContentById("featuredVideos");
    setFeaturedData(data);
  };

  return (
    <div className="FeaturedVideos">
      <img src="assets/image 7 (1).png" alt="" />
      <h1>FEATURED VIDEOS</h1>
      <div className="videosBody">
        {videoData?.map((data) => (
          <div className="slider" key={data.id}>
            <ReactPlayer
              height="100%"
              width="100%"
              controls
              autoPlay
              url={`https://${data.src.fields.file.url}`}
            />
          </div>
        ))}
      </div>
      <img src="assets/image 9 (1).png" alt="" />
    </div>
  );
}
